/* unplugin-vue-components disabled */import script from "./akb48.vue?vue&type=script&setup=true&lang=js"
export * from "./akb48.vue?vue&type=script&setup=true&lang=js"

import "./akb48.vue?vue&type=style&index=0&id=070cceb9&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070cceb9"]])

export default __exports__